<app-modal-window title="История авторизаций"
                  [actions]="false"
                  (close)="close()">
    <mat-table [dataSource]="dataSource" class="auth-history-table" matSort>

      <!-- count Column -->
      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
      </ng-container>

      <!-- dateLogin Column -->
      <ng-container matColumnDef="dateLogin">
        <mat-header-cell *matHeaderCellDef>Дата</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.dateLogin | date: 'dd.MM.yy HH:mm'}} </mat-cell>
      </ng-container>

      <!-- ip Column -->
      <ng-container matColumnDef="ip">
        <mat-header-cell *matHeaderCellDef>IP</mat-header-cell>
        <mat-cell *matCellDef="let element"><a [routerLink]="['../../../user/check/ip', element.ip]" (click)="close()">{{element.ip}}</a></mat-cell>
      </ng-container>

      <!-- country Column -->
      <ng-container matColumnDef="country">
        <mat-header-cell *matHeaderCellDef>Страна</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="country-flag-countainer">
            <img [src]="'//d2lomvz2jrw9ac.cloudfront.net/country-flags/' + element.country?.toLowerCase() + '.png'">
          </div>
          <span>&nbsp;{{element.country}}</span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="authLogsColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: authLogsColumns;"></mat-row>
    </mat-table>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
</app-modal-window>
